import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-bin",
  "use": "icon-s-bin-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-bin\"><path d=\"M9 2V1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h6v2H3V2zm10 4-.824 13.187A3 3 0 0 1 15.182 22H6.818a3 3 0 0 1-2.994-2.813L3 6zM5.129 8l.691 11.062a1 1 0 0 0 .998.938h8.364a1 1 0 0 0 .998-.938L16.87 8zM9 9a1 1 0 0 1 1 1v8a1 1 0 0 1-2 0v-8a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1v8a1 1 0 0 1-2 0v-8a1 1 0 0 1 1-1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol